export default __webpack_public_path__ + "static/media/100_19591.c374a338.jpg";